const CARDS = [
  {
    id: "app-video",
    img: "/metodo-app.webp",
    label: "App & Video", color: "#a020f0", text: "La tua scheda nell'app: serie, carichi e progressi sempre sotto controllo",
  },
  {
    id: "allenamento",
    img: "/metodo-allenamento.jpg",
    label: "Allenamento", color: "#38bdf8", text: "Forza e ipertrofia con programmi costruiti sul tuo corpo",
  },
  {
    id: "risultati",
    img: "/metodo-risultati.jpg",
    label: "Risultati", color: "#c084fc", text: "Ricomposizione corporea misurabile, settimana dopo settimana",
  },
];

export const Metodo = () => (
  <section id="metodo" data-testid="metodo-section" className="py-20 px-6 bg-[#0d0718]">
    <div className="max-w-6xl mx-auto mb-10 text-center">
      <span className="text-xs uppercase tracking-widest text-[#a020f0] font-bold mono-font">Visual Focus</span>
      <h2 className="display-font text-3xl md:text-5xl uppercase text-white mt-2">Tecnica, Intensità, Risultati</h2>
    </div>
    <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
      {CARDS.map((c) => (
        <div key={c.id} data-testid={`metodo-card-${c.id}`}
          className="relative h-64 rounded-xl overflow-hidden border border-[#2d1b4e] group">
          <img src={c.img} alt={c.label} loading="lazy"
            className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex items-end p-6">
            <div>
              <span className="text-xs font-bold uppercase" style={{ color: c.color }}>{c.label}</span>
              <p className="text-sm font-semibold text-white">{c.text}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);
